var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.generalMsg.text != '')?_c('div',{staticClass:"header-text"},[_c('div',{staticClass:"top-banner",style:("background-color:" +
      _vm.generalMsg.background_color +
      "; color:" +
      _vm.generalMsg.text_color +
      ";")},[_c('span',{staticClass:"texttop",domProps:{"innerHTML":_vm._s(_vm.generalMsg.text)}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }